import { render, staticRenderFns } from "./CardItemWithImage.vue?vue&type=template&id=597c0df5&scoped=true&"
import script from "./CardItemWithImage.vue?vue&type=script&lang=ts&"
export * from "./CardItemWithImage.vue?vue&type=script&lang=ts&"
import style0 from "./CardItemWithImage.vue?vue&type=style&index=0&id=597c0df5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c0df5",
  null
  
)

export default component.exports